Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.LinkedInContentFactory
  types:
    post: Monitoring.Models.SocialContents.LinkedInPostContent
    comment: Monitoring.Models.SocialContents.LinkedInCommentContent


  create: (socialContent) ->
    type = @types[socialContent?.content?.item_type]
    if type
      new type(socialContent)

  canHandle: (socialContent) ->
    return socialContent.group_type == 'linkedin' and socialContent.data and socialContent.sub_type
